import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Grid, IconButton } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RegistrationNumberRegExp, TransportationType, ValidTextRegExp } from "../../../Constant";
import { MyButton } from "../../../components/my-button/MyButton";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import MyContext from "../../../contexts/MyContext";
import { AddReceipt } from "./AddReceipt";

export const AddTransportReceiptDialog = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [fromAddress, setFromAddress] = useState(myContext.fromAddress);
  const [toAddress, setToAddress] = useState(myContext.toAddress);
  const [kmDriven, setKmDriven] = useState(myContext.numberOfKmDriven);
  const [registrationNumber, setRegistrationNumber] = useState(myContext.registrationNumber);
  const [registrationNumberErr, setRegistrationNumberErr] = useState("");

  const handleSaveOthers = (receipt, totalCost) => {
    myContext.changeTransportReceipt(receipt);
    myContext.changeTransportTotalCost(totalCost);
    props.onClose();
  };

  const removeAll = () => {
    myContext.changeFromAddress("");
    myContext.changeToAddress("");
    myContext.changeNumberOfKmDriven("");
    myContext.changeRegistrationNumber("");
    props.onClose();
  };

  const handleSaveOwnCar = () => {
    let isValid = true;
    let validRegistrationNumber = new RegExp(RegistrationNumberRegExp);
    if (registrationNumber.trim().length !== 0 && !validRegistrationNumber.test(registrationNumber.trim())) {
      isValid = false;
      setRegistrationNumberErr("registration_number_error_mesg");
    } else {
      setRegistrationNumberErr("");
    }
    if (isValid) {
      myContext.changeFromAddress(fromAddress);
      myContext.changeToAddress(toAddress);
      myContext.changeNumberOfKmDriven(kmDriven);
      myContext.changeRegistrationNumber(registrationNumber);
      props.onClose();
    }
  };

  useEffect(() => {
    if (!props.open) {
      setFromAddress(myContext.fromAddress);
      setToAddress(myContext.toAddress);
      setKmDriven(myContext.numberOfKmDriven);
      setRegistrationNumber(myContext.registrationNumber);
      setRegistrationNumberErr("");
    }
  }, [props.open]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <Dialog fullScreen open={props.open} onClose={props.onClose}>
          <MuiDialogTitle>
            <IconButton aria-label="close" style={{ float: "right" }} onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </MuiDialogTitle>
          <Grid container justifyContent="center" className="container custom">
            <Grid item>
              <strong>{t("add_receipt_for_expenses")}</strong>
              <p>{t("add_all_receipts_for_alternative_transport")}</p>
              <FormControl component="fieldset">
                <RadioGroup value={context.transportationType} onChange={(e, value) => context.changeTransportationType(Number(value))}>
                  <FormControlLabel value={TransportationType.USEOWNCAR} control={<Radio />} label={t("use_my_own_car")} />
                  <FormControlLabel value={TransportationType.OTHERS} control={<Radio />} label={t("other_transportation")} />
                </RadioGroup>
              </FormControl>
              <div style={{ display: context.transportationType === TransportationType.USEOWNCAR ? "initial" : "none" }}>
                <MyTextField maxLength={100} regExp={ValidTextRegExp} label={t("from_address")} value={fromAddress} onChange={setFromAddress} />
                <MyTextField maxLength={100} regExp={ValidTextRegExp} label={t("to_address")} value={toAddress} onChange={setToAddress} />
                <MyTextField regExp={"^[0-9]*$"} type="text" label={t("number_of_km_driven")} value={kmDriven} onChange={setKmDriven} />
                <MyTextField regExp={"^[^-]*$"} type="text" label={t("registration_number")} value={registrationNumber} onChange={setRegistrationNumber} helperText={t(registrationNumberErr)} />
                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                  <Grid item>
                    <MyButton textTransform="none" color="secondary" onClick={removeAll} text={t("remove")} />
                  </Grid>
                  <Grid item>
                    <MyButton textTransform="none" color="secondary" text={t("save")} onClick={handleSaveOwnCar} />
                  </Grid>
                </Grid>
              </div>
              <div style={{ display: context.transportationType === TransportationType.OTHERS ? "initial" : "none" }}>
                <p>
                  <small>{t("max_25MB_per_file")}</small>
                </p>
                <AddReceipt totalCost={context.transportTotalCost} onSave={handleSaveOthers} receipt={context.transportReceipt} {...props} />
              </div>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </MyContext.Consumer>
  );
};
